import type { NextSeoProps } from 'next-seo/pages';

import { resize } from '#utils/image/resize';

import type { BoardData } from '../../../pages/[[...board]]';
import { getImageAltText, getImageUrl } from '../image';

import { buildOpenGraphObject } from './buildOpenGraphObject';
import { buildTwitterObject } from './buildTwitterObject';
import { defaultImage } from './schema-org/constants';

export function buildBoardSeoConfig(board: BoardData, selfOrigin: string): NextSeoProps {
	const teaserImage = getImageUrl(board.image) || defaultImage(selfOrigin).url?.toString();
	const teaserImageAltText = getImageAltText({ image: board.image, seoTitle: board.seoTitle, title: board.title }) || '';
	const teaserImageResized = teaserImage ? resize(teaserImage, 'landscape', 'xxl') : '';

	const openGraph = buildOpenGraphObject({
		description: board.description,
		image: !!teaserImage ? teaserImageResized : undefined,
		imageAlt: !!teaserImage ? teaserImageAltText : undefined,
		imageHeight: !!teaserImage ? 900 : undefined,
		imageWidth: !!teaserImage ? 1600 : undefined,
		seoTitle: board.seoTitle,
		title: board.title,
		url: board.shareUrl,
	});

	// Twitter uses the `og:` properties for the rest.
	const twitter = buildTwitterObject({ handle: board.twitterHandle });

	// Misc
	const canonical = board.shareUrl || undefined;

	return { canonical, description: board.description || undefined, openGraph, title: board.seoTitle || undefined, twitter };
}
